import { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { Signup } from "@low6dev/react-feature-signup/dist";
import { createImageCdnLink } from "@low6dev/react-utils/dist";
import { Login } from "@low6dev/react-feature-auth/dist";
import { openDrawer } from "components/feature/drawer/actions";
import { handleError } from "utils";
import { useTranslations } from "hooks";
import { placeBet, setAuth } from "./actions";
import { useLocation } from "react-router-dom";
import { setBetbarParent } from "components/feature/betbar/actions";
import { loadAppStuff } from "components/feature/app/actions";
import { logXtremePush } from "utils";

import history from "router/history";

const endWidth = "94px";

const StyledWrapper = styled.div`
  padding-top: 4rem;
`;

const StyledNav = styled.nav`
  position: fixed;
  z-index: 9;
  top: ${(p) => p.theme.topbarHeight}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3rem;
  width: 100%;
  padding: 0 1rem;
  background: ${(p) => p.theme.colorCardBackground};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  @media (min-width: ${(props) => props.theme.screenWidthMd}) {
    left: 50%;
    width: ${(props) => props.theme.railWidth};
    transform: translateX(-50%);
  }
`;

const StyledToggleButton = styled.button`
  width: ${endWidth};
  flex: 0 0 ${endWidth};
  height: 2rem;
  font-size: 0.75rem;
  border-radius: 1rem;
  background: ${(p) => p.theme.colorPrimary};
  color: ${(p) => p.theme.colorPrimaryText};
`;

const StyledNavTitle = styled.div``;

const StyledHelpIconWrapper = styled.div`
  flex: 0 0 ${endWidth};
  display: flex;
  justify-content: flex-end;
  width: ${endWidth};
`;

const StyledHelpIcon = styled.button`
  padding: 0;
  color: ${(p) => p.theme.colorLabel};
`;

const Wrapper = () => {
  const dispatch = useDispatch();

  const { pathname, search } = useLocation();

  const redirect = `/${search.substring(search.indexOf("=") + 1, 100)}`;

  const [translations] = useTranslations();

  const [activePage, setActivePage] = useState(translations.signUp);

  const [loading, setLoading] = useState(true);

  const { placeBetData } = useSelector((s) => s.auth);

  const { isPlacingBet } = useSelector((s) => s.betbarParent);

  const app = useSelector((s) => s.app);

  const { tenantDetails, language } = app;

  const handleTermsAndConditionsClicked = () =>
    dispatch(
      openDrawer(process.env.REACT_APP_SLUG_TERMS, translations.termsConditions)
    );

  const handlePageButtonClicked = (page, pageTitle, useAssetsCdn) => {
    dispatch(openDrawer(page, pageTitle, useAssetsCdn));
  };

  const handlePlaceBetSuccess = () => {
    dispatch(loadAppStuff());
    history.push("/");
  };

  const attemptPlaceBet = async () => {
    if (placeBetData) {
      const selections = placeBetData?.picks;

      dispatch(
        placeBet({
          translations,
          selections,
          handlePlaceBetSuccess,
        })
      );
    } else {
      dispatch(
        setAuth({
          isLoggedIn: true,
        })
      );
      // get wallet
      try {
        const walletRes = await axios.get(`/wallet`);

        app.walletBalance = walletRes?.data?.data?.balance;
        app.walletPromoBalance = walletRes?.data?.data?.promoBalance;
      } catch (error) {
        // continue
      }
      history.push("/");
    }
  };

  const handleSignupSuccess = ({ isOver24 }) => {
    dispatch(
      setAuth({
        isOver24,
      })
    );

    logXtremePush(
      process.env.REACT_APP_XTREMEPUSH_PREFIX,
      "event",
      "signup_success"
    );

    attemptPlaceBet();
  };

  const handleLoginSuccess = ({ accessToken, isOver24 }) => {
    dispatch(
      setAuth({
        isOver24,
      })
    );

    logXtremePush(
      process.env.REACT_APP_XTREMEPUSH_PREFIX,
      "event",
      "login_success"
    );

    localStorage.setItem("fiver_react_access_token", accessToken);
    axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

    attemptPlaceBet();
  };

  useEffect(() => {
    if (pathname === "/login") {
      setActivePage(translations.login);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [pathname]);

  useEffect(() => {
    if (pathname.includes("login")) {
      setActivePage(translations.login);
      setLoading(false);
    } else {
      setActivePage(translations.signUp);
      setLoading(false);
    }
  }, [translations]);

  const toggleActivePage = () => {
    if (activePage === translations.login) {
      setActivePage(translations.signUp);
      history.push("/signup");
    } else {
      setActivePage(translations.login);
      history.push("/login");
    }
  };

  return loading ? null : (
    <StyledWrapper>
      <StyledNav>
        <StyledToggleButton onClick={toggleActivePage}>
          {activePage === translations.login
            ? translations.signUp
            : translations.login}
        </StyledToggleButton>
        <StyledNavTitle>{activePage}</StyledNavTitle>
        <StyledHelpIconWrapper>
          <StyledHelpIcon
            onClick={handleTermsAndConditionsClicked}
            className="material-icons"
          >
            help
          </StyledHelpIcon>
        </StyledHelpIconWrapper>
      </StyledNav>
      {activePage === translations.signUp && (
        <Signup
          uncheckConsentBoxesByDefault
          isNonUkForced
          isSavingPicks={isPlacingBet}
          forcedCountryCode={
            process.env.REACT_APP_SIGNUP_FORCED_COUNTRY_CODE || 44
          }
          dateInputFormat={process.env.REACT_APP_DATE_FORMAT}
          hideStepper
          hideGdprCheckboxes
          hidePushNotifcationCheckbox
          hideSmsCheckbox
          hideEmailCheckbox
          hideMobileNumberCheckbox
          hideMobileNumberAlert
          hideMobileVerificationMessage={process.env.REACT_APP_IS_MOBILE_VERIFICATION_DISABLED === "true"}
          hideDataShareCheckbox
          showGenericSignUpError
          isMobileVerificationDisabled
          isGenericMobileError
          // isMobileVerificationDisabled={
          //   process.env.REACT_APP_IS_MOBILE_VERIFICATION_DISABLED === "true"
          // }
          hidePostcode={process.env.REACT_APP_SIGNUP_HIDE_POSTCODE === "true"}
          showHasTotoAccountCheckbox
          hasTextboxDatePicker
          translations={translations}
          onPageButtonClicked={handlePageButtonClicked}
          onSuccess={handleSignupSuccess}
          onError={handleError}
          tenantDetails={tenantDetails}
          termsSlug={process.env.REACT_APP_SLUG_TERMS}
          privacySlug={process.env.REACT_APP_SLUG_PRIVACY}
          hasCustomPrivacy={process.env.REACT_APP_HAS_CUSTOM_PRIVACY === "true"}
        />
      )}
      {activePage === translations.login && (
        <Login
          isLoading={isPlacingBet}
          hideBackButton={false}
          translations={translations}
          onLoginSuccess={handleLoginSuccess}
          onError={handleError}
          appIconUrl={createImageCdnLink(
            process.env.REACT_APP_CLUB_LOGO_SQUARE
          )}
        />
      )}
    </StyledWrapper>
  );
};

export default Wrapper;
